import React from 'react'
import PropTypes from 'prop-types'
import { shuffle } from 'lodash'
import PageTitle from '../features/ui/util/page_title'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import DefaultLayout from '../layouts/default_layout'
import {
  LinkFooter,
  GabAdTopPanel,
  GabAdBottomPanel,
} from '../features/ui/util/async_components'
import RandomSidebarPanels from '../components/sidebar/random_sidebar_panels'

class BasicPage extends React.PureComponent {

  render() {
    const {
      children,
      page,
      title,
      setDocTitle
    } = this.props

    const items = RandomSidebarPanels()
    const sidebarLayout = [
      <WrappedBundle key='basic-page-ad-panel' component={GabAdTopPanel} componentParams={{ pageKey: 'basic.sidebar', position: 1 }} />,
      ...shuffle(items),
      LinkFooter,
      <WrappedBundle key='basic-page-ad-panel-bottom' component={GabAdBottomPanel} componentParams={{ pageKey: 'basic.sidebar', position: 1 }} />
    ]

    return (
      <DefaultLayout
        noComposeButton
        showBackBtn
        title={title}
        page={page}
        layout={sidebarLayout}
      >
        {setDocTitle !== false && <PageTitle path={title} />}
        {children}
      </DefaultLayout>
    )
  }

}

BasicPage.propTypes = {
  children: PropTypes.node.isRequired,
  page: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  setDocTitle: PropTypes.bool,
}

export default BasicPage
